import React from 'react';
import { RosterItem } from '../../../../app/domain/Roster/RosterItem';
import { showRosterItemEditor, updateRosterItem } from '../../../../app/initApp';
import DisplayColumn from './columns/DisplayColumn';
import NumberInputColumn from './columns/NumberInputColumn';
import SelectInputColumn from './columns/SelectInputColumn';
import TextInputColumn from './columns/TextInputColumn';

interface Props {
  columns: any;
  isMobile: boolean;
  itemNumber: string;
  rosterItem: RosterItem;
  onEdit?: (itemId: string) => void;
  onBlur?: (itemId: string) => void;
}

const RosterGridColumns: React.FC<Props> = ({ columns: rawColumns, isMobile, itemNumber, rosterItem, onEdit, onBlur }) => {
  // Reorder "YXXS" and "YXS" sizes to top
  const columns = rawColumns?.map(column => {
    if (column.id === 'size' && column.editor?.options) {
      const xsOptions = column.editor.options
        .filter(option => option.value === 'YXXS' || option.value === 'YXS')
        .sort((a, b) => (a.value === 'YXXS' ? -1 : 1));
      const otherOptions = column.editor.options.filter(option => option.value !== 'YXXS' && option.value !== 'YXS');
      return {
        ...column,
        editor: {
          ...column.editor,
          options: [...xsOptions, ...otherOptions]
        }
      };
    }
    return column;
  });

  const onRowSelected = () => {
    if (isMobile) {
      showRosterItemEditor({ props: { columns, rosterItem } });
    }
    onEdit?.(rosterItem.Id!);
  };

  return (
    <>
      {columns?.map(columnCfg => {
        const columnProps = {
          columnCfg,
          key: rosterItem.Id + columnCfg.id,
          onChange: () => updateRosterItem({ itemNumber, rosterItem }),
          onClick: undefined as unknown as () => void,
          onFocus: () => { onRowSelected(); },
          onBlur: () => onBlur?.(rosterItem.Id!),
          rosterItem
        };

        if (isMobile) {
          return (
            <DisplayColumn
              {...columnProps}
              onClick={() => { onRowSelected(); }}
            />
          );
        }

        switch (columnCfg.editor.type) {
          case 'number':
            return <NumberInputColumn {...columnProps} onBlur={columnProps.onBlur} />;
          case 'select':
            return <SelectInputColumn {...columnProps} onBlur={columnProps.onBlur} />;
          default:
            return <TextInputColumn {...columnProps} onBlur={columnProps.onBlur} />;
        }
      })}
    </>
  );
};

export default RosterGridColumns;
